export default __webpack_public_path__ + "static/media/resume-png-resume-icon-1600.1fd4b5be.png";